import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const SecurityHeroSvg = () => {
  const {theme} = useContext(ThemeContext);
  const linearGradientID = theme === 'dark' ? 'url(#paint0)' : 'url(#paint1)';

  const svgContainerStyle = {
    position: 'absolute',
    left: 'calc(50% - 70px)',
    top: 'calc(50% - 10px)',
    width: '181',
    height: '156'
  };
  const pathStyle = {
    strokeDasharray: '1200',
    strokeDashoffset: '1200',
    animation: 'draw 2s ease-in-out forwards',
    animationDelay: '1s',
    stroke: linearGradientID,
    strokeWidth: '2',
    strokeLinecap: 'round'
  };

  return (
    <div style={svgContainerStyle}>
      <svg width='181' height='156' viewBox='0 0 181 156' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M1 1C118.977 1 16.8207 155 180 155' style={pathStyle} />
        <defs>
          <linearGradient id='paint0' x1='162.812' y1='122.637' x2='-16.7169' y2='-8.73713' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#2463AC' />
            <stop offset='1' stopColor='#A3CDFF' stopOpacity='0' />
          </linearGradient>
          <linearGradient id='paint1' x1='215' y1='248' x2='-55.7636' y2='-38.8656' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#FE7518' />
            <stop offset='1' stopColor='#FE7518' stopOpacity='0' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default SecurityHeroSvg;

